"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setTimeTakenUser = exports.transformImage = exports.flipImage = void 0;
const immer_1 = require("immer");
const TRANSFORM_IMAGE = "opening_image.transform_image";
const ROTATE_IMAGE_ABSOLUTE = "opening_image.rotate_image_absolute";
const SCALE_IMAGE_ABSOLUTE = "opening_image.scale_image_absolute";
const RESIZE_IMAGE = "opening_image.resize_image";
const FLIP_IMAGE = "opening_image.flip_image";
const SET_TIME_TAKEN_USER = "opening_image.set_time_taken_user";
function flipImage(imageId, flipX, flipY = false) {
    return {
        type: FLIP_IMAGE,
        __IMAGE_ID__: imageId,
        flipX,
        flipY,
    };
}
exports.flipImage = flipImage;
function transformImage(imageId, transform, rotationStep = 0) {
    return {
        type: TRANSFORM_IMAGE,
        __IMAGE_ID__: imageId,
        transform,
        rotationStep,
    };
}
exports.transformImage = transformImage;
function setTimeTakenUser(imageId, timeTakenUser) {
    return {
        type: SET_TIME_TAKEN_USER,
        __IMAGE_ID__: imageId,
        timeTakenUser,
    };
}
exports.setTimeTakenUser = setTimeTakenUser;
exports.default = (0, immer_1.produce)((draft, action) => {
    if (draft === undefined) {
        return null;
    }
    switch (action.type) {
        case FLIP_IMAGE:
            draft.flipX = action.flipX;
            draft.flipY = action.flipY;
            break;
        case SCALE_IMAGE_ABSOLUTE:
            const scale = action.width / draft.width;
            const aspect = draft.width / draft.height;
            draft.x -= (draft.width * (scale - 1)) / 2;
            draft.y -= (draft.height * (scale - 1)) / 2;
            draft.width = action.width;
            draft.height = action.width / aspect;
            break;
        case RESIZE_IMAGE:
            const diffX = action.width - draft.width;
            const diffY = action.height - draft.height;
            //draft.x -= diffX / 2;
            //draft.y -= diffY / 2;
            draft.width = action.width + 1;
            draft.height = action.height + 1;
            break;
        case ROTATE_IMAGE_ABSOLUTE:
            draft.rotation = action.rotation % 360;
            break;
        case TRANSFORM_IMAGE:
            const transform = Object.assign({ x: draft.x, y: draft.y, rotation: draft.rotation, width: draft.width, height: draft.height }, action.transform);
            // Position
            draft.x = transform.x;
            draft.y = transform.y;
            // Size
            draft.width = transform.width;
            draft.height = transform.height;
            // Rotation includes wrap-around and step functionality
            draft.rotation = transform.rotation % 360;
            break;
        case SET_TIME_TAKEN_USER:
            draft.timeTakenUser = action.timeTakenUser;
            break;
        default:
            break;
    }
});
//# sourceMappingURL=data:application/json;base64,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